// Liens du canal apporteurs : fonctions pures, sans client HTTP (testables
// sans charger axios).

/**
 * Lien de parrainage d'un code. Le serveur le fournit quand une adresse
 * d'inscription est configurée (la landing, par exemple) ; sinon il pointe
 * sur l'inscription de CETTE application, ce qui suit l'environnement.
 */
export const lienParrainage = (code: string, lienServeur?: string): string => {
  if (lienServeur) return lienServeur;
  return `${window.location.origin}/register?ref=${encodeURIComponent(code)}`;
};

/** Lien de partage WhatsApp (wa.me) d'un message. */
export const lienWhatsApp = (message: string): string =>
  `https://wa.me/?text=${encodeURIComponent(message)}`;
